import React from 'react';
import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import * as ErrorMonitor from 'core/ErrorMonitor';
import GlobalStoreProvider from './store';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './bootstrap.scss';

ErrorMonitor.init();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: true,
      cacheTime: 1000 * 60 * 30, // 30 min
      retry: false,
    },
  },
});

ReactDOM.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={() => <>An error has occurred</>}>
      <QueryClientProvider client={queryClient}>
        <GlobalStoreProvider>
          <App />
          {process.env.NODE_ENV === 'development' && <ReactQueryDevtools initialIsOpen={false} />}
        </GlobalStoreProvider>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorkerRegistration.register();
